import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const Scanner = lazy(() => import('./Scanner'));

const ScannerRoute: FuseRouteItemType = {
	path: '/scanner',
	element: <Scanner />
};

export default ScannerRoute;
